import PropTypes from 'prop-types';
import React from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Button,
    CardContent,
    Grid,
    IconButton,
    Modal,
    Tooltip,
    Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import DeleteIcon from '@mui/icons-material/Delete';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import VenueService from 'services/VenueService';
import useApi from 'hooks/useApi';

const Body = React.forwardRef(({ handleClose, deletePrice }, ref) => (
    <div ref={ref} tabIndex={-1}>
        <MainCard
            sx={{
                position: 'absolute',
                width: { xs: 280, md: 450 },
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }}
            headersx={{
                p: '10px 18px'
            }}
            title="Delete Price"
            content={false}
            secondary={
                <IconButton onClick={handleClose} size="large">
                    <CloseIcon fontSize="small" />
                </IconButton>
            }
        >
            <CardContent>
                <Typography>Do you really want to Delete?</Typography>
                <Grid container justifyContent="flex-end" mt={2}>
                    <Grid item>
                        <Button
                            color="error"
                            variant="contained"
                            startIcon={<DoneRoundedIcon fontSize="small" />}
                            onClick={deletePrice}
                        >
                            Delete
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </MainCard>
    </div>
));

Body.propTypes = {
    modalStyle: PropTypes.object,
    handleClose: PropTypes.func
};

// ==============================|| EDIT MODAL ||============================== //

export default function DeleteAlert({ priceUuid, setReload }) {

    const theme = useTheme();
    const [open, setOpen] = React.useState(false);

    /* ---------- Event Callbacks ---------- */
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const deletePrice = () => {
        deletePriceApi.execute(priceUuid);
    }

    /* ---------- API Success Handlers ---------- */
    const deletePriceHandler = () => {
        setReload(r => !r)
        setOpen(false);
    }

    /* ---------- API's ---------- */
    const deletePriceApi = useApi(VenueService.removePriceByUuid, deletePriceHandler, true);

    return (
        <>
            <Tooltip placement="top" title="Delete">
                <IconButton
                    color="primary"
                    sx={{
                        color: theme.palette.orange.dark,
                        borderColor: theme.palette.orange.main,
                        '&:hover ': { background: theme.palette.orange.light }
                    }}
                    onClick={handleOpen}
                    size="large"
                >
                    <DeleteIcon sx={{ fontSize: '1.1rem' }} />
                </IconButton>
            </Tooltip>
            <Modal open={open} onClose={handleClose} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
                <Body deletePrice={deletePrice} handleClose={handleClose} />
            </Modal>
        </>
    );
}
